export default {
      id: "close-usage",
      viewBox: "0 0 64 64",
      url: __webpack_public_path__ + "img/icons.f163a2c6.svg#close",
      toString: function () {
        return this.url;
      }
    }